// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ff2V","type":"styles_type__2MG9z","choices":"styles_choices__2JwK7"};